module.exports = __webpack_public_path__ + "static/media/sarah.c6e9ed04.jpg";